import { Box } from "@mui/material";
import { useState } from "react";
import LabelChip from "../../../../../components/LabelChip";
import LabelsDropdown from "./LabelsDropdown";

export default function LabelChipWithDropDown({ label, color, entities }) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  return (
    <Box>
      <LabelChip
        text={label}
        size="M"
        type="outline"
        onClick={(event) => setMenuAnchorEl(event.currentTarget)}
        color={color}
      />
      {menuAnchorEl && (
        <LabelsDropdown
          selectedEntities={entities}
          menuAnchorEl={menuAnchorEl}
          setMenuAnchorEl={setMenuAnchorEl}
        />
      )}
    </Box>
  );
}
